varying vec2 vUv;

uniform float transitionProgress;
uniform float displacementIntensity;
uniform sampler2D texture1;
uniform sampler2D texture2;
uniform sampler2D displacementTexture;
uniform vec2 resolution;
uniform vec2 imageResolution1;
uniform vec2 imageResolution2;

float PI = 3.1415926535897932384626433832795;

vec2 coverUv(vec2 uv, vec2 screenSize, vec2 imageSize) {
	float screenRatio = screenSize.x / screenSize.y;
	float imageRatio = imageSize.x / imageSize.y;
	vec2 scale = screenRatio < imageRatio
		? vec2(screenRatio / imageRatio, 1.0)
		: vec2(1.0, imageRatio / screenRatio);
	return (uv - 0.5) * scale + 0.5;
}

void main() {
	vec2 uv = vUv;
	vec2 dispVec = texture2D(displacementTexture, uv).rg;
	float progress = transitionProgress;

	vec2 uv1 = coverUv(uv + dispVec * displacementIntensity * progress, resolution, imageResolution1);
	vec2 uv2 = coverUv(uv - dispVec * displacementIntensity * (1.0 - progress), resolution, imageResolution2);

	vec4 color1 = texture2D(texture1, uv1);
	vec4 color2 = texture2D(texture2, uv2);

	gl_FragColor = mix(color1, color2, progress);
}
